import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { isEmpty } from 'lodash';

import { useApi, useHandbook } from '~/hooks';
import { getBusinessById } from '~/api/businesses';
import { Business } from '~/types';

const { Option } = Select;

interface Props {
  placeholder?: string;
  country?: Business['country'];
  [x: string]: any;
}

const IndividualDocumentTypeInput: FC<Props> = (props) => {
  const { solutionId, country, ...rest } = props;
  const { data, isLoading } = useHandbook();

  const [{ data: business, loading: businessLoading, error }, businessQuery] = useApi<Business>(
    getBusinessById,
    [],
    {
      lazy: true,
    }
  );
  useEffect(() => {
    if (!country && !businessLoading && isEmpty(business) && !error) {
      businessQuery();
    }
  }, [country, businessQuery, businessLoading, business, error]);
  const resultCountry = country || business?.country;

  const handbookCountry = resultCountry
    ? data?.countries?.find((item) => item.id === resultCountry)
    : null;
  const individualDocuments = handbookCountry?.individualDocuments;
  const { t } = useTranslation();

  return (
    <Select loading={isLoading || businessLoading} placeholder={t('companyLegalType')} {...rest}>
      {individualDocuments?.map((item) => {
        const legalType = item.type;
        return (
          <Option key={legalType} value={legalType || ''}>
            {legalType}
          </Option>
        );
      })}
    </Select>
  );
};

export default IndividualDocumentTypeInput;
